export default "__VITE_ASSET__DhtlSbJ7__"